import { useTheme } from "@mui/material/styles";

// Hook that provides permissions/settings styles
export const usePermissionsStyles = () => {
  const theme = useTheme();

  return {
    root: {
      margin: "auto",
    },
    rootActionTab: {
      flexGrow: 1,
    },
    formSpacing: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      "& > *": {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
      },
      [theme.breakpoints.down("xl")]: {
        "& > *": {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
          marginLeft: theme.spacing(0.5),
          marginRight: theme.spacing(0.5),
        },
      },
    },
    cardHeader: {
      padding: theme.spacing(1, 2),
    },
    list: {
      width: 425,
      height: 455,
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
    },
    actionsList: {
      width: 500,
      height: 500,
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
    },
    card: {
      minWidth: 425,
      minHeight: 470,
    },
    loadingSpinner: {
      position: "relative" as const,
      top: 130,
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
    smallLoadingSpinner: {
      position: "relative" as const,
      top: 10,
      right: 5,
    },
  };
};

// For backward compatibility
const permissionsStyles = usePermissionsStyles;
export default permissionsStyles;
